import memoise from "../utils/memoise";
import store from "../../state/store";

const getPathogenicityName = memoise((pathogenicity) => {
  if (!pathogenicity) return null;
  const state = store.getState();
  if (!state.initialDataLoaded) return pathogenicity;
  if (pathogenicity.length > 3) {
    for (let i = 0; i < state.variantClassesList.length; i++) {
      const vc = state.variantClassesList[i];
      if (vc.name === pathogenicity) {
        return pathogenicity;
      }
    }
  } else if (state.variantClasses[pathogenicity]) {
    return state.variantClasses[pathogenicity].name;
  }
  return null;
});
export default getPathogenicityName;
